import React from "react";

// Official Continex logo (coral wordmark with swirl mark).
// Transparent PNG works on both light and dark backgrounds.
const Logo = ({ className = "" }) => {
  return (
    <img
      src="/brand/continex-logo.png"
      alt="Continex"
      className={`h-9 w-auto md:h-10 ${className}`}
    />
  );
};

export default Logo;
